import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchCartWishlistSearch } from 'b2b-apps/shop/cart/redux/wishlistSearch/actionCreators';
import { FetchCartWishlistSearchAction } from 'b2b-apps/shop/cart/redux/wishlistSearch/types';

type UseFetchCartWishlistSearchActionReturnType = (
  query: string,
) => FetchCartWishlistSearchAction;

const useFetchCartWishlistSearchAction = (): UseFetchCartWishlistSearchActionReturnType => {
  const dispatch = useDispatch();

  return useMemo(
    () => bindActionCreators(fetchCartWishlistSearch, dispatch),
    [dispatch],
  );
};

export type { UseFetchCartWishlistSearchActionReturnType };
export { useFetchCartWishlistSearchAction };
